import React from 'react';
import PropTypes from 'prop-types';
import MUiContainer from '@material-ui/core/Container';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

class Container extends React.PureComponent {
  render() {
    const { position, classes, className, top, left, zIndex, style: otherStyle, ...otherProps } = this.props;
    const style = { top, left, zIndex, ...otherStyle };
    const classPosition = classes[position];
    const fullWidthClass = otherProps.maxWidth === false ? 'MuiContainer-full-width' : '';
    return (
      <MUiContainer {...otherProps} style={style} className={`${classPosition} ${fullWidthClass} ${className || ''}`} />
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  position: PropTypes.oneOf(['relative', 'fixed', 'absolute']),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Container.defaultProps = {
  maxWidth: false,
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 2,
};

export default withStyles(styles)(Container);
